"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeArray = exports["default"] = void 0;
/**
 * Normalize an array of objects
 *
 * @param {String|Func} key
 * @param {Array} array
 * @param {Function} keyExtractor //optional
 *
 * Example Input:
 * param key = 'name';
 * param array = [{name: 'frank', age: 19}, {name: 'joe', age: 22}, {name: 'bob', age: 44}]
 *
 * Example return:
 * {
 *   'frank': {name: 'frank', age: 19} ,
 *   'joe': {name: 'joe', age: 22} ,
 *   'bob': {name: 'bob', age: 44} ,
 * }
 */
var normalizeArray = exports.normalizeArray = function normalizeArray(key, array) {
  var obj = {};
  array.forEach(function (e) {
    var objectKey = typeof key === 'function' ? key(e) : e[key];
    obj[objectKey] = e;
  });
  return obj;
};
var _default = exports["default"] = {
  normalizeArray: normalizeArray
};